"use client";

import React, { useId } from "react";
import Script from "next/script";
import { AspectRatio } from "components/ui/aspect-ratio";
import { analytics } from "lib/segment";
import { usePathname, useSearchParams } from "next/navigation";

interface YoutubeEmbedTrackerProps {
  videoId: string;
  title: string;
  segmentMsg: string;
  segmentOpt: Record<string, any>;
}

export const YoutubeEmbedTracker = ({
  videoId,
  title,
  segmentMsg,
  segmentOpt,
}: YoutubeEmbedTrackerProps) => {
  const uniqueId = useId().replace(/:/g, "");
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const onPlayerStateChange = (event: any) => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const currentPath = pathname || window.location.pathname;
    const queryString = searchParams.toString();
    const fullPath = queryString
      ? `${currentPath}?${queryString}`
      : currentPath;

    if (event.data === 1) {
      if (
        typeof window !== "undefined" &&
        (window.OnetrustActiveGroups == undefined ||
          window.OnetrustActiveGroups?.includes("2"))
      ) {
        analytics.track(segmentMsg, {
          ...segmentOpt,
          youtube_video_id: videoId,
          video_current_time: event.target.getCurrentTime(),
          video_duration: event.target.getDuration(),
          url: fullPath,
          page_base_url: baseUrl,
          page_full_url: baseUrl + fullPath,
        });
      }
    }
  };

  const initializePlayer = () => {
    const checkYT = () => {
      if (
        typeof window !== "undefined" &&
        window.YT &&
        typeof window.YT.Player === "function"
      ) {
        new window.YT.Player(uniqueId, {
          events: {
            onStateChange: onPlayerStateChange,
          },
        });
      } else {
        setTimeout(checkYT, 100);
      }
    };
    checkYT();
  };

  return (
    <div className="h-full w-full">
      <AspectRatio ratio={16 / 9}>
        <iframe
          id={uniqueId}
          title={title}
          src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="h-full w-full rounded-lg pb-1"
        ></iframe>
      </AspectRatio>

      <Script
        src="https://www.youtube.com/iframe_api"
        strategy="afterInteractive"
        onReady={initializePlayer}
      />
    </div>
  );
};
